export default __webpack_public_path__ + "static/media/emailtempl.f7d0ac5a.png";